import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  box-sizing: border-box;\n  min-height: 100%;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from 'styled-components';
import { flexContainer } from './utils';
var Page = styled.div(_templateObject(), flexContainer({
  flexDirection: 'column'
}));
export default Page;